export const MuiAvatar = {
    styleOverrides: {
        root: ({ theme }) => ({
            // borderRadius: '20%',
            borderRadius: '9999px',
            outlineColor: `color-mix(in oklab, var(--gp-palette-common-black) 20%, transparent)`,
            outlineOffset: '-1px',
            outlineWidth: '1px',
            outlineStyle: 'solid',
            verticalAlign: 'middle',
            // `theme.palette.Avatar.defaultBg` how to set this var?
            backgroundColor: theme.palette.text.muted,
        }),
    },
};
